import React from 'react';
import { reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';

import { ReportFieldEnum } from 'Common/FieldEnum';
import { EXTENDED_BENEFITS_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components';
import { ReportFormatButtonGroup } from 'Components/forms/ReportFormatButtonGroup';

const ExtendedBenefits = props => {
  return (
    <Form>
      <TitledCard title={'Report Parameters'}>
        <Grid>
          <Grid.Column>
            <Grid.Row>
              Extended Benefits Report for the Fiscal Year{' '}
              {props.getFiscalYearString()}.
            </Grid.Row>
            <Grid.Row>
              <ReportFormatButtonGroup
                formName={EXTENDED_BENEFITS_FORM_NAME}
                fieldName={ReportFieldEnum.ReportFormat}
              />
            </Grid.Row>
          </Grid.Column>
        </Grid>
      </TitledCard>
    </Form>
  );
};

export const ExtendedBenefitsForm = reduxForm({
  form: EXTENDED_BENEFITS_FORM_NAME,
  destroyOnUnmount: false,
})(ExtendedBenefits);



// WEBPACK FOOTER //
// ./src/pages/extendedbenefits/components/ExtendedBenefitsForm.js